(() => {
  function init(root) {
    const lineups = [...root.querySelectorAll('[data-lineup]')];
    if (root.matches?.('[data-lineup]')) lineups.unshift(root);
    lineups.forEach((lineup) => {
      if (lineup.dataset.lineupReady) return;
      lineup.dataset.lineupReady = 'true';
      const track = lineup.querySelector('[data-lineup-track]');
      const cards = [...track.querySelectorAll('[data-lineup-card]')];
      const controls = lineup.querySelector('[data-lineup-controls]');
      const previous = lineup.querySelector('[data-lineup-prev]');
      const next = lineup.querySelector('[data-lineup-next]');
      const range = lineup.querySelector('[data-lineup-range]');
      let frame;
      function update() {
        const overflow = track.scrollWidth - track.clientWidth;
        controls.hidden = overflow <= 2;
        track.tabIndex = overflow > 2 ? 0 : -1;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= overflow - 2;
        const bounds = track.getBoundingClientRect();
        const visible = cards.map((card, i) => {
          const box = card.getBoundingClientRect();
          return Math.min(box.right, bounds.right) - Math.max(box.left, bounds.left) >= box.width * .6 ? i + 1 : null;
        }).filter(Boolean);
        if (visible.length) range.textContent = visible[0] + '–' + visible[visible.length - 1] + ' / ' + cards.length + ' models';
      }
      const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
      function move(direction) {
        if (!cards.length) return;
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
        track.scrollTo({ left: track.scrollLeft + direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', schedule, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || controls.hidden) return;
        if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'instant' });
          else move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      track.addEventListener('focusin', schedule);
      const observer = new ResizeObserver(schedule);
      observer.observe(track);
      const unload = (event) => {
        if (event.target.contains(lineup)) {
          observer.disconnect();
          cancelAnimationFrame(frame);
          document.removeEventListener('shopify:section:unload', unload);
        }
      };
      document.addEventListener('shopify:section:unload', unload);
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest('[data-lineup-card]');
    if (card) card.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
})();
